<template>
  <div class="search-rlsj">
    <div class="u-p5-x-3">
      <template>
        <h4 style="color: aliceblue;margin-top: -30px">
          车辆闸机检索
        </h4>
      </template>
      <car-form
        ref="carForm"
        @submit="submit"
        :showformitem="formItemshow"
        :default-form-value="defaultFormValue"
      >
        <el-button
          type="warning"
          size="small"
          :loading="exportingYellow"
          @click="exportPlateColor('yellow')"
        >导出黄牌车</el-button>
        <el-button
          type="success"
          size="small"
          :loading="exportingNonYellow"
          @click="exportPlateColor('nonYellow')"
        >导出非黄牌车</el-button>
      </car-form>
    </div>
    <div style="padding: 0 20px">
      <div class="traffic-total" v-show="totalTraffic !== null">
        总车流量：{{ totalTraffic }}
      </div>
      <car-img-list
        v-if="imageList.length > 0"
        @carshow="carimgShow"
        :key="refreshKey"
        :image-list="imageList"
        :showlistitem="['cartime', 'plateNumber']"
      ></car-img-list>
      <div style="text-align: center; color: #b3b3b3; padding: 0.5rem 0" v-show="loading">
        <i style="font-size: 0.38rem;color#FFF" class="el-icon el-icon-loading"></i>
      </div>
      <div
        v-show="imageList.length == 0 && !loading"
        style="text-align: center; color: #b3b3b3; padding: 0.5rem 0"
      >
        查询结果为空
      </div>
    </div>
  </div>
</template>

<script>
import CarForm from "@/components/form/carForm.vue";
import CarImgList from "@/components/carImgList.vue";
export default {
  components: {
    CarForm,
    CarImgList,
  },
  data() {
    const typeTime = {
      beginTime: this.$myPlug.timeFormat(
        //new Date().getTime() - 60000 * 60 * 24 * 1,
        new Date().getTime(),
        "yyyy-mm-dd 00:00:00"
      ),
      endTime: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd hh:MM:ss"),
    };
    return {
      setTimer: null,
      isEnd: false,
      loading: false,
      exportingYellow: false,
      exportingNonYellow: false,
      defaultFormValue: {
        cartime: Object.values(typeTime),
      },
      form: { ...typeTime },
      pageRow: 12,
      pageIndex: 1,
      totalTraffic: null,
      refreshKey: "t1",
      formItemshow: [
        "plateNo",
        "plateColor",
        "cartollgate",
        //"deviceType",
        "vehicleType",
        "cartime",
        "carFrom",
      ],
      imageList: [],
    };
  },
  methods: {
    submit(form) {
      this.isEnd=false
      this.form = form;
      this.form.beginTime = form.beginTime || form.cartime[0];
      this.form.endTime = form.endTime || form.cartime[1];
      this.pageIndex = 1;
      this.getList();
    },
    carimgShow(data) {
      this.$store.commit("boxDetail", {
        carList: data,
        showCard: ["过车信息", "数据信息"],
        title: "详情",
      });
    },
    getExportForm(exportType) {
      const form = this.$refs.carForm ? { ...this.$refs.carForm.form } : { ...this.form };
      const timeRange = form.cartime || form["0"];
      if (timeRange && timeRange.length >= 2) {
        form.beginTime = timeRange[0];
        form.endTime = timeRange[1];
      }
      form.plateNo = `${form.carprefix || ""}${form.plateNo || ""}`;
      form.deviceType = 2;
      form.exportType = exportType;
      return form;
    },
    exportPlateColor(exportType) {
      const form = this.getExportForm(exportType);
      if (!form.beginTime || !form.endTime) {
        this.$message.warning("请选择导出时间范围");
        return;
      }
      const loadingKey = exportType === "yellow" ? "exportingYellow" : "exportingNonYellow";
      const fileName = exportType === "yellow" ? "黄牌车导出.xlsx" : "非黄牌车导出.xlsx";
      this[loadingKey] = true;
      this.$axios({
        method: "post",
        url: "/dqi-hymanage/motorvehicle/exportPlateColor",
        data: form,
        responseType: "blob",
        timeout: 120000
      })
        .then(res => {
          const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this[loadingKey] = false;
        });
    },
    getList(from) {
      if (from !== "add") {
        this.imageList = [];
        this.totalTraffic = null;
      }
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      this.form.deviceType = 2;
      this.$http
        .POST_motorvehiclePage(this.form)
        .then((response) => {
          this.loading = false;
          this.totalTraffic =
            response.totalTraffic != null ? response.totalTraffic : response.total || 0;
          if(response.data&&response.data.length){
          response.data.forEach((item, index) => {
            this.imageList.push(
              Object.assign({}, item, {
                img: item.storageUrl1 || "../../static/img/img_error2.png",
                largeImg: item.storageUrl1,
                cartime: item.passingTimeFormat,
                tollgate: item.tollgateName,
                plateNumber: item.plateNo,
                plateColor: item.plateColor,
              })
            );
          });
          console.log(this.imageList);
          this.refreshKey = new Date().getTime();
          }else{
            this.$message("数据已请求完")
            this.isEnd=true
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    scroll(e) {
      // console.log(e.target.scrollTop);
      const bottomHeight =
        e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;
      if (bottomHeight < 300&&!this.isEnd) {
        this.loading = true;
        if (this.setTimer) clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          this.pageIndex += 1;
          this.getList("add");
        }, 500);
      }
    },
  },
  mounted() {
    document.querySelector(".index-main").addEventListener("scroll", this.scroll);
  },
  created() {
    this.getList();
  },
  destroyed() {
    document.querySelector(".index-main").removeEventListener("scroll", this.scroll);
  },
};
</script>

<style scoped>
.traffic-total {
  color: #fff;
  font-size: 0.18rem;
  line-height: 0.3rem;
  margin-bottom: 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/views/search/clzj.vue